import React from 'react'
import AccountsPage from 'components/accounts_page'
import LandingPage from './landing'
import {connect} from 'react-redux'
import Cookies from 'js-cookie'

const HomePage=(props)=>{
  if(props.isAuthenticated){
    return (<AccountsPage/>)
  }else{
    return (<LandingPage/>)
  }
}

const mapStateToProps=(state)=>{
  return {
    isAuthenticated: state.user.authenticated && Cookies.get("stories_session")
  }
}

export default connect(mapStateToProps)(HomePage)



// WEBPACK FOOTER //
// ./src/components/home_page/index.js